/*
  QB touch rows (Stage W4). On touch devices up to 1024px the theme's Swiper is not started on the product rows
  (featured-collection sliders, recently viewed, recommended products, the shoppable videos fork); the rows scroll
  natively instead — overflow-x, scroll-snap, overscroll containment and touch-action live in assets/qb-global.css
  under .qb-native-row. Dropping the theme's "carousel" class before the sections load is all that is needed:
  Carousel() in theme.js only builds a Swiper for a node that carries that class (or contains a .swiper).
  Loaded synchronously from the footer group, so it runs before theme.js (a deferred module) loads the sections.
  Skipped in the theme editor so section reloads keep their Swiper and the theme's unload hooks.
*/
(function () {
  if (window.__qbTouchRows) return;
  window.__qbTouchRows = true;
  if (window.Shopify && window.Shopify.designMode) return;
  if (!window.matchMedia('(pointer: coarse) and (max-width: 1024px)').matches) return;
  var SEL = '.featured-collection-slider__content.carousel, .recently-viewed-products__content.carousel, .recommended-products__content.carousel, .shoppable-videos__carousel.carousel';
  function adopt(el) {
    if (el.classList.contains('qb-native-row')) return;
    el.classList.remove('carousel');
    el.classList.add('qb-native-row');
    var sec = el.closest('[data-section-type]');
    var per = parseInt((sec && sec.getAttribute('data-products-per-view')) || el.getAttribute('data-columns-tablet') || el.getAttribute('data-columns-desktop') || '4', 10) || 4;
    if (per === 5) per = 4; // the theme also shows 4 across between 720 and 1200
    el.style.setProperty('--qb-per-view', String(per));
    sizes(el, per);
  }
  // W2 follow-up: the theme's card images carry a sizes attribute for its own grid (and a "/0" slot on the sliders),
  // so the browser picked a thumbnail for a 78vw card and it rendered blurred. Tell it the real slot width.
  function sizes(row, per) {
    var phone = window.matchMedia('(max-width: 767px)').matches;
    var value = phone ? '78vw' : 'calc((100vw - 36px - 14px * ' + (per - 1) + ') / ' + per + ')';
    var imgs = row.querySelectorAll('img[srcset]');
    for (var i = 0; i < imgs.length; i++) if (imgs[i].getAttribute('sizes') !== value) imgs[i].setAttribute('sizes', value);
  }
  function scan(root) {
    if (root.matches && root.matches(SEL)) adopt(root);
    var list = root.querySelectorAll ? root.querySelectorAll(SEL) : [];
    for (var i = 0; i < list.length; i++) adopt(list[i]);
    // cards rendered later (recently viewed, recommendations) land inside an adopted row
    var row = root.closest ? root.closest('.qb-native-row') : null;
    if (row) sizes(row, parseInt(row.style.getPropertyValue('--qb-per-view'), 10) || 4);
  }
  scan(document);
  new MutationObserver(function (records) {
    records.forEach(function (r) {
      for (var i = 0; i < r.addedNodes.length; i++) if (r.addedNodes[i].nodeType === 1) scan(r.addedNodes[i]);
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
